import '../styles/marquee.css'

export default function Marquee () {
    return(
        <div className="marquee">
        <div className="marquee-content">
            <span>
                Bored of reading on what date Mughal empire came? Book a session with us and explore the Mughal empire's rise with a front seat to their king's council and a bird's eye view to the wars they fought
            </span>
            <span>
                Bored of reading on what date Mughal empire came? Book a session with us and explore the Mughal empire's rise with a front seat to their king's council and a bird's eye view to the wars they fought
            </span>
        </div>
    </div>
    )
}